import packageInfo from '../../../../package.json';

export const environment = {
  // The company logo upload posts here directly rather than through GraphQL.
  apiUrl: 'https://api.staging.iqd-pro.com',
  production: true,
  version: `v${packageInfo.version} (staging)`,
  graphql: {
    uri: 'https://api.staging.iqd-pro.com/graphql',
    wsUri: 'wss://api.staging.iqd-pro.com/graphql',
  },
  auth0: {
    domain: 'auth.staging.iqd-pro.com',
    clientId: 'p6oGUpIgFQDYmzSKhY1y8EckVpVg9VJ9',
    audience: 'https://api.staging.iqd-pro.com',
    claimsNamespace: 'https://iqd-pro.com/claims/',
    // Auth0's recommended setup for a SPA on a custom domain: renew through a
    // first-party silent-auth iframe and keep nothing renewable in browser
    // storage. Relies on the Auth0 domain being same-site with the app, which
    // holds here — both sit under iqd-pro.com.
    useSilentAuth: true,
  },
  sentry: {
    dsn: 'https://ec169c76049458ddfa4910201c3f7791@o4509351712194560.ingest.de.sentry.io/4509354979885136',
    environment: 'staging',
  },
  // Production is the only environment that reports to GTM. Development and
  // staging traffic would otherwise land in the live container and count as
  // real sessions in GA4.
  gtm: {
    id: 'GTM-58ZRKSX',
    enabled: false,
  },
  links: {
    budgetCalculator: 'https://budget.test.iqd-pro.com',
    viewer3d: 'https://3d-viewer.test.iqd-pro.com/',
  },
};
